import { Controller } from "@hotwired/stimulus"

const CHECKPOINT_VALUE = "checkpoint"
const MAX_CHECKPOINT = 60000

export default class extends Controller {
  static targets = [
    "function",
    "checkpointNumber",
    "letter",
    "uuid",
    "major",
    "minor",
    "label",
  ]
  static values = {
    uuid: String,
  }

  connect() {
    this.update()
  }

  update() {
    const isCheckpoint = this.functionTarget.value === CHECKPOINT_VALUE
    this.checkpointNumberTarget.disabled = !isCheckpoint

    const letter = this.letterTarget.value
    const minor = letter ? letter.toUpperCase().charCodeAt(0) - 64 : ""

    let major
    let functionName

    if (isCheckpoint) {
      major = this.normalizedCheckpointNumber()
      functionName = `Checkpoint_${major}`
    } else {
      major = this.functionTarget.value
      functionName = this.functionTarget.selectedOptions[0]?.text?.split(" (")[0] || ""
    }

    this.uuidTarget.textContent = this.uuidValue
    this.majorTarget.textContent = major
    this.minorTarget.textContent = minor
    this.labelTarget.textContent = `BR_${functionName}_BOX_${letter}`
  }

  normalizedCheckpointNumber() {
    let value = parseInt(this.checkpointNumberTarget.value, 10)
    if (!Number.isFinite(value) || value < 1) value = 1
    if (value > MAX_CHECKPOINT) value = MAX_CHECKPOINT
    this.checkpointNumberTarget.value = value
    return value
  }
}
